import { IS_PRODUCTION } from "@/config";

export const acFormProxy = "/api/ac-form";
export const acFormUrl = IS_PRODUCTION
  ? "https://narrative.activehosted.com/proc.php"
  : "https://narrative1597701264.activehosted.com/proc.php";
